import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Users = () => {
  return (
    <EmptyPage
      title="User Management"
      description="Manage user accounts, view user activity, and control access to your real estate platform for team members and stakeholders."
      icon="👥"
    />
  );
};

export default Users;
